export default __webpack_public_path__ + "locales/ko-KR/WebPlugins.json?hash=73ff8547c864b1844b97d1c0f7e01ec3";